module.exports = __webpack_public_path__ + "img/icon-esquerda-cima.900d4ed0.png";